import { minPasswordLength, passwordMinCharsPerClass, passwordMinClasses } from '@gonfalon/constants/constants';
// eslint-disable-next-line no-restricted-imports
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import {
  checkPasswordCharacters,
  isLength,
  isNotEmpty,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

export type FacilitatedTrialType = {
  email: string;
  firstName: string;
  lastName: string;
  organization: string;
};

export class FacilitatedTrial extends Record<FacilitatedTrialType>({
  email: '',
  firstName: '',
  lastName: '',
  organization: '',
}) {}

export type FacilitatedTrialSignUpFormType = {
  password: string;
};

export class FacilitatedTrialSignUpForm extends Record<FacilitatedTrialSignUpFormType>({
  password: '',
}) {
  validate() {
    let predicates = [isNotEmpty('password')];
    predicates = predicates.concat(
      isNotEmpty('password'),
      isLength(minPasswordLength())('password'),
      checkPasswordCharacters({
        requiredCharCountPerClass: passwordMinCharsPerClass(),
        requiredClassCount: passwordMinClasses(),
      })('password'),
    );

    return validateRecord(this, ...predicates);
  }
}

export function createFacilitatedTrialSignupForm(props: CreateFunctionInput<FacilitatedTrialSignUpForm> = {}) {
  return props instanceof FacilitatedTrialSignUpForm ? props : new FacilitatedTrialSignUpForm(fromJS(props));
}

export function createFacilitatedTrial(props: CreateFunctionInput<FacilitatedTrial> = {}) {
  return props instanceof FacilitatedTrial ? props : new FacilitatedTrial(fromJS(props));
}
